// components/user/Heading.js
import React from "react";
import { useNode } from "@craftjs/core";
import {
    FormControl,
    FormLabel,
    Select,
    MenuItem,
    Grid,
    Typography,
    TextField,
    Paper,
    Box,
    Slider
} from "@material-ui/core";

export const Heading = ({
                            text,
                            fontSize,
                            color,
                            textAlign,
                            level,
                            margin
                        }) => {
    const {
        connectors: { connect, drag },
        selected,
        actions: { setProp }
    } = useNode((node) => ({
        selected: node.events.selected
    }));

    // Determine which heading tag to use based on level
    const HeadingTag = `h${level}`;

    return (
        <div ref={ref => connect(drag(ref))}>
            {/* Heading Content */}
            <div
                style={{
                    margin: `${margin}px 0`,
                }}
            >
                <HeadingTag
                    style={{
                        fontSize: `${fontSize}px`,
                        color,
                        textAlign,
                        margin: 0,
                        padding: 0,
                    }}
                    contentEditable={selected}
                    onBlur={(e) => setProp(props => props.text = e.target.innerText)}
                    suppressContentEditableWarning={true}
                >
                    {text}
                </HeadingTag>
            </div>

            {/* Settings Panel */}
            {selected && (
                <Box sx={{ mt: 2 }}>
                    <Paper>
                        <Box sx={{ p: 2 }}>
                            <Typography variant="subtitle2" gutterBottom>
                                Heading Settings
                            </Typography>
                            <Grid container spacing={2}>
                                {/* Heading Level */}
                                <Grid item xs={6}>
                                    <FormControl fullWidth size="small">
                                        <FormLabel>Level</FormLabel>
                                        <Select
                                            value={level}
                                            onChange={(e) => setProp(props => props.level = e.target.value)}
                                        >
                                            <MenuItem value={1}>H1</MenuItem>
                                            <MenuItem value={2}>H2</MenuItem>
                                            <MenuItem value={3}>H3</MenuItem>
                                            <MenuItem value={4}>H4</MenuItem>
                                            <MenuItem value={5}>H5</MenuItem>
                                            <MenuItem value={6}>H6</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Text Alignment */}
                                <Grid item xs={6}>
                                    <FormControl fullWidth size="small">
                                        <FormLabel>Alignment</FormLabel>
                                        <Select
                                            value={textAlign}
                                            onChange={(e) => setProp(props => props.textAlign = e.target.value)}
                                        >
                                            <MenuItem value="left">Left</MenuItem>
                                            <MenuItem value="center">Center</MenuItem>
                                            <MenuItem value="right">Right</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Font Size */}
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <FormLabel>Font Size (px)</FormLabel>
                                        <Slider
                                            value={fontSize}
                                            onChange={(_, value) => setProp(props => props.fontSize = value)}
                                            min={12}
                                            max={72}
                                            step={1}
                                            marks={[
                                                { value: 12, label: '12' },
                                                { value: 42, label: '42' },
                                                { value: 72, label: '72' }
                                            ]}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Color */}
                                <Grid item xs={6}>
                                    <FormControl fullWidth size="small">
                                        <FormLabel>Color</FormLabel>
                                        <TextField
                                            value={color}
                                            onChange={(e) => setProp(props => props.color = e.target.value)}
                                            placeholder="#000000"
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Margin */}
                                <Grid item xs={6}>
                                    <FormControl fullWidth size="small">
                                        <FormLabel>Margin (px)</FormLabel>
                                        <TextField
                                            type="number"
                                            value={margin}
                                            onChange={(e) => setProp(props => props.margin = parseInt(e.target.value))}
                                            inputProps={{ min: 0 }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                </Box>
            )}
        </div>
    );
};

// Default props and Craft.js configuration
Heading.craft = {
    props: {
        text: "Heading",
        fontSize: 32,
        color: "#000000",
        textAlign: "left",
        level: 2,
        margin: 16
    },
    related: {
        toolbar: true,
        settings: true
    }
};